export var Lang;
(function (Lang) {
    Lang["Chinese"] = "zh-CN";
    Lang["English"] = "en-US";
})(Lang || (Lang = {}));
